import { lazy } from 'react';

export const LazyNewsletterSection = lazy(() => import('../NewsletterSection'));